import React from "react";
import ProductCard from "../../../components/controls/ProductCard";

const ProductPreview = ({ formData, lang, priceTypesList }) => {
  if (!formData) return null;
  return (
    <div className="">
      <ProductCard
        product={formData}
        lang={lang}
        priceTypesList={priceTypesList}
      />
    </div>
  );
};

export default ProductPreview;
